import { PREDEFINED_QUERIES } from '@app/config/media-queries';
import styled from 'styled-components';

export const ScheduleTableContainer = styled.a`
  padding: 10px;
  display: flex;
  flex-direction: row;
  background-color: #4286f5;
  box-shadow: 0px 4px 4px rgba(173, 181, 189, 0.25);
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  border-radius: 5px;
  height: 60px;
  text-decoration: none;

  @media screen and (${PREDEFINED_QUERIES.isTabletOrLess}) {
    margin: 20px 15px 0 15px;
    height: 50px;
  }
`;

export const ScheduleTableText = styled.span`
  color: #fff;
  font-weight: bold;
  margin-right: 10px;
  font-size: 12px;
`;

export const ScheduleTableButton = styled.div`
  background-color: #004ab5;
  width: 27px;
  height: 27px;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  display: flex;
`;

export const ScheduleTableIcon = styled.img`
  width: 100px;
  height: 30px;

  @media screen and (${PREDEFINED_QUERIES.isTabletOrLess}) {
    width: 90px;
  }
`;

export const ScheduleTableRightSide = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
